function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import Button from '../../Button';
import React from 'react';
import { useFullScreen } from '..';

const Trigger = ({
  as: Component = Button,
  onClick,
  render,
  children,
  ...props
}) => {
  const [isFullScreen] = useFullScreen();

  const handleFullScreen = event => {
    if (onClick) {
      onClick(event);
    }

    if (isFullScreen) {
      document.exitFullscreen = document.webkitExitFullscreen || document.exitFullscreen;
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen = document.documentElement?.webkitRequestFullscreen || document.documentElement.requestFullscreen;
      document.documentElement.requestFullscreen();
    }
  };

  return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    onClick: handleFullScreen
  }), render ? render(isFullScreen) : children);
};

export default Trigger;